/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_UndoInputs */



/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Assistant_Saved_Prompt_UndoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_undo = /** @type {((inputs?: Assistant_Saved_Prompt_UndoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_UndoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückgängig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshacer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("撤销")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ववत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Anular")
	return /** @type {LocalizedString} */ ("Undo")
});